import { exists } from '@/api'

export interface SystemBatchMenuDetail {
  key: string
  value: string
}

export function SystemBatchMenuDetailFromJSON(
  json: any
): SystemBatchMenuDetail {
  return {
    key: exists(json, 'key') ? json.key : '',
    value: exists(json, 'value') ? json.value : ''
  }
}
